import React from 'react';
import { Card, CardContent, Typography, Alert } from '@mui/material';
import StepActions from '../components/StepActions'; import { formatPhone } from '../lib/validation';
export default function AgentStep({ view, onNext, onBack }) {
  const a = view.salesAgent;
  return (<>
    {a.name ? (<Card variant="outlined"><CardContent><Typography variant="subtitle1">{a.name}</Typography><Typography color="text.secondary">{[formatPhone(a.phone || ''), a.email].filter(Boolean).join(' · ')}</Typography></CardContent></Card>)
      : <Alert severity="info">No sales agent is attached to this invitation.</Alert>}
    <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>This comes from your invitation. If it is wrong, tell us in the notes when our team follows up — they can correct it during review.</Typography>
    <StepActions onBack={onBack} onNext={onNext} />
  </>);
}
